import { render, staticRenderFns } from "./AuthorizedParentView.vue?vue&type=template&id=37cf87ee&scoped=true&"
import script from "./AuthorizedParentView.vue?vue&type=script&lang=js&"
export * from "./AuthorizedParentView.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedParentView.vue?vue&type=style&index=0&id=37cf87ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf87ee",
  null
  
)

export default component.exports